import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import { isMobile } from "../../utils/platform.js";
import styles from "./styles.css";
import { useTrack } from "@tkww/ads-content-component-analytics/react";
import getTrackingData from "../../data/index.js";
export default function InstagramGallery(_ref) {
  var _context;
  var infos = _ref.infos,
    designerName = _ref.designerName;
  var follow = (infos === null || infos === void 0 ? void 0 : infos.follow) || designerName;
  var trackingData = getTrackingData("clickThroughToWebsite");
  var _useTrack = useTrack(trackingData === null || trackingData === void 0 ? void 0 : trackingData.name, trackingData === null || trackingData === void 0 ? void 0 : trackingData.data),
    track = _useTrack.track;
  var handleClick = function handleClick(e) {
    var defaultParams = JSON.parse(e.target.closest("a").getAttribute("data-analytics"));
    if (defaultParams) track(defaultParams);
  };
  var instagramCard = function instagramCard(img) {
    var img_id = isMobile() && img.mobile_img_id ? img.mobile_img_id : img.desktop_img_id;
    var linkingUrl = (img === null || img === void 0 ? void 0 : img.linkingUrl) || (infos === null || infos === void 0 ? void 0 : infos.linkingUrl);
    return /*#__PURE__*/React.createElement("div", {
      className: styles.instagramCard,
      style: {
        height: 0,
        paddingBottom: "100%"
      },
      key: img_id
    }, /*#__PURE__*/React.createElement("a", {
      className: "instagram-card-link",
      href: linkingUrl,
      target: "_blank",
      rel: "nofollow",
      "aria-label": infos["aria_label"],
      "data-analytics": "{\"selection\": \"instagram image\", \"userDecisionArea\": \"instagram section\", \"destinationUrl\": \"".concat(linkingUrl, "\"}"),
      onClick: handleClick
    }, /*#__PURE__*/React.createElement(Picture, {
      id: img_id,
      lazy: true,
      pixelDensities: [1, 2],
      env: "production"
    }, /*#__PURE__*/React.createElement(Source, {
      viewport: "md",
      width: 166
    }), /*#__PURE__*/React.createElement(Source, {
      viewport: "lg",
      width: 215
    }), /*#__PURE__*/React.createElement(Img, {
      width: 215,
      alt: img === null || img === void 0 ? void 0 : img.img_alt
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.instagramSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.instagramContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sectionTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.instagramDescription
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.instagramFollow
  }, "Follow "), /*#__PURE__*/React.createElement("a", {
    id: "instagram-designer-link",
    href: infos === null || infos === void 0 ? void 0 : infos.linkingUrl,
    target: "_blank",
    rel: "nofollow",
    onClick: handleClick,
    "data-analytics": "{\"selection\": \"designer name\", \"userDecisionArea\": \"instagram section\", \"destinationUrl\": \"".concat(infos === null || infos === void 0 ? void 0 : infos.linkingUrl, "\"}")
  }, "@", follow))), /*#__PURE__*/React.createElement("div", {
    className: styles.instagramCards
  }, infos === null || infos === void 0 ? void 0 : _mapInstanceProperty(_context = infos.imgs).call(_context, instagramCard))));
}